/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentClassificationCreateRequest
 */
export interface TournamentClassificationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TournamentClassificationCreateRequest
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentClassificationCreateRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentClassificationCreateRequest
     */
    totalPositions: number;
}

/**
 * Check if a given object implements the TournamentClassificationCreateRequest interface.
 */
export function instanceOfTournamentClassificationCreateRequest(value: object): value is TournamentClassificationCreateRequest {
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('totalPositions' in value) || value['totalPositions'] === undefined) return false;
    return true;
}

export function TournamentClassificationCreateRequestFromJSON(json: any): TournamentClassificationCreateRequest {
    return TournamentClassificationCreateRequestFromJSONTyped(json, false);
}

export function TournamentClassificationCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentClassificationCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryId': json['categoryId'],
        'name': json['name'],
        'totalPositions': json['totalPositions'],
    };
}

export function TournamentClassificationCreateRequestToJSON(json: any): TournamentClassificationCreateRequest {
    return TournamentClassificationCreateRequestToJSONTyped(json, false);
}

export function TournamentClassificationCreateRequestToJSONTyped(value?: TournamentClassificationCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryId': value['categoryId'],
        'name': value['name'],
        'totalPositions': value['totalPositions'],
    };
}

